import { Controller } from '@hotwired/stimulus';

// TODO: review and consolidate with multiple_choice_quiz_task_controller.js
export default class extends Controller {
  static targets = ['form'];

  initialize() {
    this.readOnly = this.element.dataset.readOnly === 'true';
    if (!this.readOnly) {
      this.nextTaskButton = document.querySelector('.task-button.next');
      this.nextPageUrl = this.nextTaskButton.href; // Store the URL for the next page
      this.nextTaskButton.href = '#';
      this.nextTaskButton.classList.add('disabled');
      this.preventNextTask = this.preventNextTask.bind(this);
      this.nextTaskButton.addEventListener('click', this.preventNextTask);
    }
  }

  connect() {
    this.checkFormCompletion();
  }

  disconnect() {
    if (!this.nextTaskButton) return;
    this.nextTaskButton.removeEventListener('click', this.preventNextTask); // Remove the event listener
  }

  preventNextTask(event) {
    event.preventDefault();
    this.saveAnswers();
    this.checkFormCompletion();
  }

  checkFormCompletion() {
    if (!this.hasFormTarget) return false;

    const allInputs = this.formTarget.querySelectorAll('input, select, textarea');
    const allFilled = Array.from(allInputs).every(input => {
      if (input.dataset.required === 'false') return true; // Skip required check if data-required is false
      if (input.type === 'checkbox' || input.type === 'radio') {
        return Array.from(this.formTarget.querySelectorAll(`input[name="${input.name}"]`)).some(checkbox => checkbox.checked);
      }
      return input.value.trim() !== '';
    });

    if (allFilled) {
      if (!this.nextTaskButton) return;
      this.nextTaskButton.href = this.nextPageUrl; // Restore the URL for the next page
      this.nextTaskButton.classList.remove('disabled');
      this.nextTaskButton.removeEventListener('click', this.preventNextTask); // Remove the event listener
    }
  }

  saveAnswers() {
    this.hasFormTarget && this.formTarget.requestSubmit();
  }
}
